import { Component } from '@angular/core';
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-created-book',
  standalone: true,
  imports: [
    FormsModule
  ],
  templateUrl: './created-book.component.html',
  styleUrl: './created-book.component.scss'
})
export class CreatedBookComponent {

}
